import { EmbeddedAnalyticsState } from 'reducers/embeddedAnalytics';

export const embeddedAnalyticsSelector = (state: { EmbeddedAnalyticsPanelSlice: EmbeddedAnalyticsState }) =>
  state.EmbeddedAnalyticsPanelSlice;
